import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { GDAuthInterface, Menu } from '../../model/gd-auth';
import { GDStorageInterface } from '../../model/gd-storage';
import { LoopBackConfig } from '../../shared/sdk/lb.config';

@Injectable()
export class SFGOAuthService {

  public menu: Menu;
  private SFGoStorage: GDStorageInterface;
  private SFGoAuth: GDAuthInterface;

  constructor(
    public storage: Storage
  ) { }

  getSFGOAuth(): Observable<any> {
    return Observable.create((observer) => {
      this.storage.ready().then(
        () => {
          this.storage.get('SFGoAuth').then(
            result => {
              const SFGoAuth = JSON.parse(result);
              observer.next(SFGoAuth);
              observer.complete();
            }
          );
        }
      )
    })
  }

  // getSFGOStorage(): Observable<any> {
  //   return Observable.create((observer) => {
  //     this.storage.get('SFGoStorage').then(
  //       result => {
  //         const SFGoAuth = JSON.parse(result);
  //         observer.next(SFGoAuth);
  //         observer.complete();
  //       }
  //     );
  //   })
  // }

  getAuthorization(): Promise<GDAuthInterface> {
    return new Promise(async (resolve) => {
      try {
        await this.storage.ready();
        const SFGoAuth = await this.storage.get('SFGoAuth');
        if(SFGoAuth) {
          this.SFGoAuth = SFGoAuth ? JSON.parse(SFGoAuth) : SFGoAuth;

          this.menu = this.SFGoAuth.menu;
          const LBpath = this.SFGoAuth.path;
  
          /** set path loopback */
          if (LBpath !== '' && LBpath !== undefined && LBpath != null) {
            LoopBackConfig.setBaseURL(LBpath);
          } else {
            LoopBackConfig.setBaseURL(LoopBackConfig.getDefaultPath());
          }
          resolve(this.SFGoAuth);
        } else {
          resolve();
        }
      }
      catch (error) {
        console.log(error);
        resolve();
      }
    });
  }

  getGDStorage(): Promise<GDStorageInterface> {
    return new Promise(async (resolve) => {
      try {
        await this.storage.ready();
        let SFGoStorage = await this.storage.get('SFGoStorage');
        this.SFGoStorage = SFGoStorage ? JSON.parse(SFGoStorage) : SFGoStorage;

        resolve(this.SFGoStorage);
      }
      catch (error) {
        console.log(error);
        resolve();
      }
    });
  }

  isGopathNew(): Promise<boolean> {
    return new Promise(async (resolve) => {
      resolve(true);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/sfgoauth.service/sfgoauth.service.ts